import {Action} from '@ngrx/store';
import {type} from '../../shared';


export const previewInvoicesActionTypes = {
  LOAD: type('[Invoice Preview] Add'),
  LOAD_ALREADY: type('[Invoice Preview] LOAD ALREADY'),
  LOAD_SUCCESS: type('[Invoice Preview] Add Success'),
  LOAD_FAIL: type('[Invoice Preview] Add Fail'),
  LOAD_FAIL_CONFLICT: type('[Invoice Preview] Add Fail Conflict'),
  CLEAR: type('[Invoice Preview] CLEAR '),
};

export class PreviewInvoicesAction implements Action {
  readonly type = previewInvoicesActionTypes.LOAD;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}
export class PreviewAlreadyInvoicesAction implements Action {
  readonly type = previewInvoicesActionTypes.LOAD_ALREADY;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}

export class PreviewInvoicesSuccessAction implements Action {
  readonly type = previewInvoicesActionTypes.LOAD_SUCCESS;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}

export class PreviewInvoicesFailAction implements Action {
  readonly type = previewInvoicesActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
export class PreviewInvoicesFailConflictAction implements Action {
  readonly type = previewInvoicesActionTypes.LOAD_FAIL_CONFLICT;
  constructor(public payload?: string) {}
}

export class PreviewInvoicesClearAction implements Action {
  readonly type = previewInvoicesActionTypes.CLEAR;
  constructor(public payload?: string) {}
}
